import React from 'react';
import { motion } from 'framer-motion';
import { FaBriefcase, FaCalendar, FaMapMarkerAlt, FaCheckCircle } from 'react-icons/fa';

const Experience = () => {
  const achievements = [
    'Designed and developed scalable, enterprise-grade web applications using MERN stack with MySQL',
    'Improved backend query response time through optimized indexing & aggregation pipelines',
    'Implemented robust state-management architecture using Redux Toolkit, Redux Saga & Zustand',
    'Built modern, type-safe applications with Next.js and TypeScript - reduced runtime bugs by 40%',
    'Spearheaded integration of AI-powered features (LangChain, Pinecone Vector DB & RAG)',
    'Enabled intelligent chatbots & contextual search - increased user engagement significantly',
    'Collaborated onsite with cross-functional teams (Product, Design, QA) to translate business requirements',
    'Delivered 3 major projects ahead of schedule',
    'Engineered secure authentication flows using JWT, bcrypt & RBAC - zero security incidents post-deployment',
    'Automated routine data-processing tasks using cron jobs, saving 15+ hours/week of manual effort',
    'Deployed & monitored applications on Vercel & Railway with CI/CD pipelines for zero-downtime releases',
  ];

  return (
    <section className="experience section" id="experience">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Professional Experience</h2>
          <p className="section-subtitle">My journey in web development</p>
        </motion.div>

        <motion.div
          className="experience-card"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="experience-header">
            <div className="company-logo">
              <FaBriefcase />
            </div>
            <div className="experience-info">
              <h3>MERN Stack Developer</h3>
              <h4>Stack Up Solutions</h4>
              <div className="experience-meta">
                <span>
                  <FaCalendar /> January 2023 - Present
                </span>
                <span>
                  <FaMapMarkerAlt /> Onsite
                </span>
              </div>
            </div>
          </div>

          <div className="experience-description">
            <p>
              Leading full-stack development initiatives, architecting scalable web applications, and integrating
              cutting-edge AI technologies to deliver exceptional digital solutions for enterprise clients.
            </p>
          </div>

          <div className="achievements">
            <h4>Key Achievements & Responsibilities:</h4>
            <ul>
              {achievements.map((achievement, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                  viewport={{ once: true }}
                >
                  <FaCheckCircle className="check-icon" />
                  <span>{achievement}</span>
                </motion.li>
              ))}
            </ul>
          </div>

          <div className="tech-stack">
            <h4>Technologies Used:</h4>
            <div className="tech-tags">
              {[
                'MongoDB',
                'Express.js',
                'React.js',
                'Node.js',
                'Next.js',
                'TypeScript',
                'Redux',
                'Zustand',
                'MySQL',
                'PostgreSQL',
                'LangChain',
                'Pinecone',
                'RAG',
                'JWT',
                'Socket.io',
                'Tailwind CSS',
                'Material-UI',
                'Vercel',
                'Railway',
                'Git',
              ].map((tech, index) => (
                <span key={index} className="tech-tag">
                  {tech}
                </span>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Experience;